import { getRequest } from '..';

export function getProvinces() {
  return getRequest('/province');
}
